import React, { Fragment, useEffect, useState } from "react";
import { faTimes, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loader from "react-loader-spinner";
import swal from "sweetalert";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import "./GoalChange.css";

const counselorLabel = (item) =>
  item?.counselor?.name ||
  item?.name ||
  [item?.first_name, item?.last_name].filter(Boolean).join(" ") ||
  item?.email ||
  "Counselor";

const counselorValue = (item) =>
  item?.counselor?.id || item?.id || "";

const ContactCounselor = ({ setOpenContactConselor }) => {
  const [counselor, setCounselor] = useState("");
  const [messageText, setMessageText] = useState("");
  const [counselorList, setCounselorList] = useState([]);
  const [sending, setSending] = useState(false);
  const user =
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"));

  const canSubmit = Boolean(counselor && messageText.trim() && !sending);

  useEffect(() => {
    if (!user?.school_id) return;
    GetStudentService.getCounselorName("", "counselor", user.school_id)
      .then((data) => {
        setCounselorList(data?.data?.objects || data?.data?.result || []);
      })
      .catch(() => {
        setCounselorList([]);
      });
  }, [user?.school_id]);

  const sendCounselorMessage = () => {
    if (!canSubmit) return;
    const dstId = parseInt(counselor, 10);
    if (!dstId) {
      swal({
        text: "Please select a counselor.",
        icon: "warning",
        buttons: { OK: true },
      });
      return;
    }

    const obj = {
      dst_id: [dstId],
      event_type: "school_it_counselor",
      message_body: messageText.trim(),
    };

    setSending(true);
    GetStudentService.sendMessage(obj)
      .then((data) => {
        setMessageText("");
        setCounselor("");
        setOpenContactConselor(false);
        swal({
          text: data?.data?.Status || "Message sent successfully.",
          icon: "success",
          buttons: { OK: true },
        });
      })
      .catch(() => {
        swal({
          text: "Unable to send message. Please try again.",
          icon: "error",
          buttons: { OK: true },
        });
      })
      .finally(() => setSending(false));
  };

  return (
    <Fragment>
      <div
        className="profile-drawer-overlay"
        onClick={() => !sending && setOpenContactConselor(false)}
      />
      <aside className="profile-drawer" role="dialog" aria-labelledby="contact-counselor-title">
        <div className="profile-drawer-header">
          <h3 id="contact-counselor-title" className="profile-drawer-title">
            New Message
          </h3>
          <button
            type="button"
            className="profile-drawer-close"
            onClick={() => setOpenContactConselor(false)}
            aria-label="Close"
            disabled={sending}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="profile-drawer-body">
          <div className="profile-drawer-field">
            <label className="profile-drawer-label" htmlFor="contact-counselor">
              To
            </label>
            <select
              id="contact-counselor"
              className="profile-drawer-select"
              value={counselor}
              onChange={(e) => setCounselor(e.target.value)}
              disabled={sending}
            >
              <option value="">Select Counselor</option>
              {counselorList.map((item, index) => (
                <option key={counselorValue(item) || index} value={counselorValue(item)}>
                  {counselorLabel(item)}
                </option>
              ))}
            </select>
          </div>

          <div className="profile-drawer-field">
            <label className="profile-drawer-label" htmlFor="contact-message">
              Message
            </label>
            <textarea
              id="contact-message"
              className="profile-drawer-textarea"
              placeholder="Type your message"
              value={messageText}
              onChange={(e) => setMessageText(e.target.value)}
              disabled={sending}
            />
          </div>
        </div>

        <div className="profile-drawer-footer">
          <button
            type="button"
            className="admin-ccplus-btn ghost"
            onClick={() => setOpenContactConselor(false)}
            disabled={sending}
          >
            <FontAwesomeIcon icon={faTimes} />
            Cancel
          </button>
          <button
            type="button"
            className="admin-ccplus-btn primary"
            disabled={!canSubmit}
            onClick={sendCounselorMessage}
          >
            {sending ? (
              <Loader type="TailSpin" color="#fff" height={16} width={16} />
            ) : (
              <FontAwesomeIcon icon={faPaperPlane} />
            )}
            {sending ? "Sending..." : "Send Message"}
          </button>
        </div>
      </aside>
    </Fragment>
  );
};

export default ContactCounselor;
